import { render, staticRenderFns } from "./locationcard.vue?vue&type=template&id=22366d26&lang=true&"
import script from "./locationcard.vue?vue&type=script&lang=js&"
export * from "./locationcard.vue?vue&type=script&lang=js&"
import style0 from "./locationcard.vue?vue&type=style&index=0&id=22366d26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports